<template>
  <div>
    <div
      v-if="formatAdmin"
      class="text-left pd-b-3 pd-t-4 flex-display js-end"
    >
      <a
        @click="setCourse(),edit = false,dialogDescussionForumVisible = true"
        class="color-primary-light"
        >+ เพิ่มกระดานถาม-ตอบ</a
      >
    </div>
    <div v-else class="flex-display js-between ai-center pd-b-3 column-mobile">
      <div class="flex-display ai-center width-100 ">
        <div>
          <span class="circle-adjunct color-bg-secondary">
            <i class="fas fa-comment-alt"></i>
          </span>
        </div>
        <h3 class="text-font-24 pd-l-4 mg-y-less text-left">
          กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)
        </h3>
      </div>
      <div class="width-100 text-right">
        <el-button
          @click="
            $router.push(
              `/create/discussion/forum?courseId=${$route.query.courseId}&subjectId=${$route.query.subjectId}`
            )
          "
          type="warning"
          round
          class="pd-x-2"
          >ตั้งกระทู้</el-button
        >
      </div>
    </div>

    <el-table
      v-if="showTable"
      :data="discussionForum"
      border
      :header-row-style="tableHeaderStyle"
      :header-cell-style="tableHeaderStyle"
      empty-text="ไม่พบข้อมูล"
      v-loading="loading"
    >
      <el-table-column
        v-if="user.role != 0"
        type="index"
        label="ลำดับ"
        header-align="center"
        align="center"
        width="80"
      ></el-table-column>
      <el-table-column
        :width="widthMax < 767.98 ? '160' : ''"
        prop="title"
        :label="showSubjecNameLabel?`กระทู้ วิชา${subject.name}`:'ชื่อกระดานถาม - ตอบระหว่างเรียน'"
        header-align="center"
      >
        <template slot-scope="scope">
          <a
            :href="`/discussion/forum/detail?courseId=${$route.query.courseId}&subjectId=${$route.query.subjectId}&discussionId=${scope.row._id}`"
            target="_blank"
            class="cursor-pointer color-black"
            >{{ scope.row.title }}</a
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="reply"
        label="จำนวนคนตอบ"
        width="100"
        header-align="center"
        align="center"
        sortable
      >
        <template slot-scope="scope">{{ scope.row.reply[0] }}</template>
      </el-table-column>
      <el-table-column
        prop="viewers"
        label="จำนวนคนดู"
        width="100"
        header-align="center"
        align="center"
        sortable
      ></el-table-column>
      <el-table-column
          prop="durationTime"
          label="เปิด-ปิด กระดานถาม-ตอบ"
          header-align="center"
          align="center"
          width="180"
        >
          <template slot-scope="scope">
            <span v-if="typeof scope.row.durationTime !== 'undefined' && scope.row.durationTime.open">
              {{ scope.row.durationTime.open | dateTimeThShort }} -
              {{ new Date(scope.row.durationTime.close).setHours(23,59,59) | dateTimeThShort }}
            </span>
            <span v-else>-</span>
          </template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="คนสร้างกระทู้"
        :width="
          widthMax < 767.98
            ? '130'
            : widthMax < 1199
            ? '130'
            : widthMax > 1200
            ? '220'
            : ''
        "
        header-align="center"
        align="center"
        sortable
      >
        <template slot-scope="scope">{{
          scope.row.createdBy
        }}</template>
      </el-table-column>
      <el-table-column
        prop="updatedAt"
        label="อัปเดตล่าสุดเมื่อ"
        :width="
          widthMax < 767.98
            ? '160'
            : widthMax < 1199
            ? '160'
            : widthMax > 1200
            ? '250'
            : ''
        "
        header-align="center"
        align="center"
        sortable
      >
        <template slot-scope="scope">{{
          scope.row.updatedAt | dateTimeTh
        }}</template>
      </el-table-column>
      <el-table-column
        v-if="user.role != 0"
        label
        width="100"
        header-align="center"
        align="center"
      >
        <template slot-scope="scope">
          <div class="flex-display ai-center js-center">
            <div class="box-action">
              <div
                @click="openEditDescussionForum(scope.row)"
                class="circle-action color-bg-secondary"
              >
                <i class="fas fa-pen"></i>
              </div>
            </div>
            <div class="box-action">
              <el-popconfirm
                confirmButtonText="ใช่"
                cancelButtonText="ไม่"
                icon="el-icon-info"
                iconColor="red"
                title="ท่านต้องการลบรายการนี้ใช่หรือไม่"
                @onConfirm="delDescussionForum(scope.row._id)"
              >
                <div
                  slot="reference"
                  class="circle-action color-bg-danger-lighter"
                >
                  <i class="fas fa-trash-alt"></i>
                </div>
              </el-popconfirm>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="discussionForumConst.length > 10" class="pd-y-3">
      <el-pagination
        @current-change="changePage"
        background
        layout="prev, pager, next"
        :total="discussionForumConst.length"
        :page-size="10"
        :current-page="page"
      ></el-pagination>
    </div>

    <el-dialog
      title
      :visible.sync="dialogDescussionForumVisible"
      width="90%"
      top="1vh"
    >
      <div v-loading="loadingDialog">
        <div class="text-left pd-b-3 border-b">
          <h2 class="mg-less text-font-24 color-black">
            {{`${edit?'แก้ไข':'เพิ่ม'}กระดานถาม - ตอบระหว่างเรียน (Discussion Forum)`}}
          </h2>
        </div>
        <div class="text-left">
          <p class="text-font-16">
            <span class="color-black">ชื่อหลักสูตร: </span>
            <span class="color-gray">{{ course.name }}</span>
            <span class="color-black pd-l-4">วิชา: </span>
            <span class="color-gray">{{ subject.name }}</span>
          </p>
        </div>
        <div v-if="dialogDescussionForumVisible" class="modal-page">
          <DiscussionForumForm 
            @createDiscussionForum="createDiscussionForum" 
            @updateDiscussionForum="updateDiscussionForum" 
            :descussion="descussion" 
            :edit="edit" 
            :startDate="subject.durationTime.open?subject.durationTime.open:''" 
            :endDate="subject.durationTime.close?subject.durationTime.close:''"/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import { tableHeaderStyle } from "@/service/table";
import DiscussionForumForm from "@/components/discussionForum/DiscussionForumForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DiscussionForumForm,
  },
  props: {
    discussionForumConst: {
      type: Array,
      default() {
        return [];
      },
    },
    showSubjecNameLabel: {
      type: Boolean,
      default() {
        return true;
      },
    },
    formatAdmin: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },

  computed: {
    discussionForum() {
      return this.discussionForumConst.slice(
        (this.page - 1) * 10,
        this.page * 10
      );
    },
    token() {
      return this.$store.state.token;
    },
    user() {
      return this.$store.state.user;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      widthMax: window.innerWidth,
      showTable:true,
      page: 1,
      dialogDescussionForumVisible: false,
      loading: false,
      loadingDialog: false,
      course: "",
      subject: "",
      descussion:null,
      edit:false
    };
  },
  mounted() {
    this.setCourse();
    window.addEventListener("resize", this.resize);
  },
  methods: {
    resize() {
      this.showTable = false
      this.widthMax= window.innerWidth
      setTimeout(() => {
        this.showTable = true
      }, 200);

    },
    setCourse() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    changePage(page) {
      this.page = page;
    },
    delDescussionForum(id) {
      this.loading = true;

      let obj = {
        _id: id,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`delete/discussion`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("delDescussionForum error", e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openEditDescussionForum(data){
      this.setCourse();
      this.edit = true
      this.descussion = data
      this.dialogDescussionForumVisible = true;
    },
    createDiscussionForum(data) {
      this.loadingDialog = true;

      let obj = {
        subjectId: this.$route.query.subjectId,
        title: data.name,
        durationTime: {
          open: data.distanceDate[0],
          close: data.distanceDate[1],
        },
        description: data.description,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`discussion`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
            this.dialogDescussionForumVisible = false;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createDiscussionForum error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
    updateDiscussionForum(data) {
      this.loadingDialog = true;
      
      let obj = {
        _id: data.id,
        title: data.name,
        durationTime: {
          open: data.distanceDate[0],
          close: data.distanceDate[1],
        },
        description: data.description,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.put(`discussion`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$emit("fetchSubjectId");
            this.dialogDescussionForumVisible = false;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createDiscussionForum error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
  },
};
</script>


<style scoped>
</style>
